import { Component, EventEmitter, Input, Output, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LayoutUtilsService } from 'src/app/core/layout-utils.service';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { Artikel } from '../../store/models/artikel';
import { Warenkorb } from '../../store/models/warenkorb';
import { Webshops } from '../../store/models/webshops';
import { WarenkorbsService } from '../../webshops/warenkorbs/shared/warenkorbs.service';
import { ArtikelsService } from '../shared/artikels.service';
import { ArtikelQuickView1Component } from '../artikel-quick-view1/artikel-quick-view1.component';
import { Kurse } from '../../store/models/kurse';

class SelectedArtikel {
    artikel: any;
    menge: number;
    isMatrixArtikel: boolean;
}

@Component({
    selector: 'kkis-app-webshop-kurse',
    templateUrl: './kurse.component.html',
    styleUrls: ['./kurse.component.scss']
})
export class KurseComponent implements OnInit, OnChanges {

    @Input()
    artikelKennung: number;

    @Input() 
    menge: number = 1;

    // User
    loggedInUser: Webshops.ILoggedInUser;

    // Warenkorb
    warenkorb: Warenkorb.IWarenkorbDto;

    // Artikel
    //artikel: Artikel.IArtikelDto[];
    //kurse: 
    kurse: Kurse.IKurseDto[];

    responsiveOptions;

    // (from local <<NOT>> FROM DATABASE)
    imgDummy: string = "assets/media/svg/files/no-image.svg";

    // Dialog
    dialogWidth: string;
    dialogHeight: string;

    // Utils
    isLoading: boolean = true;
    isLoggedIn: boolean = false;
    isSubmitted: boolean = false;

    selectedKursId:number;
    selectedTerminId:number;
    dynArrParticipant: string[] = []; // Dynamisches Array zum Speichern der bereits eingetippten Namen
        
    constructor(
        private dialog: MatDialog,
        private layoutUtilsService: LayoutUtilsService,
        private authService: AuthService,
        private warenkorbsService: WarenkorbsService,
        private artikelsService: ArtikelsService,
    ) { }

    
    ngOnInit(): void {

        //ToDo: Kennung als Parameter übergeben 
        //console.log('jetzt init mit kennung: '+this.artikelKennung);

        // auf Kurse umbauen
        this.artikelsService.getKurse(this.artikelKennung).subscribe(res => {

                console.log(res);               

                //gibt es Kurse?
                if (res.length > 0) {
                    this.kurse = res;
                }

                this.isLoading = false;
               
        });

        this.authService.isAuthenticated$.subscribe(x => {
            this.isLoggedIn = x;
        });

    }
    
    toggledisplayheight() {
        //$('.zub_artikel_list').toggleClass('expanded');        
    }
       
    onSelectKursItem(event) {



        if ($(event.target).hasClass('participant')) {

        } else {

            //Teilnehmer merken
            var elem_selected = $('.kurs.selected');
            
            this.dynArrParticipant = []; 
            for (let i = 0; i < $(elem_selected).find('.participant').length; i++) {
                let p = $(elem_selected).find('#participant'+i).val();
                this.dynArrParticipant.push(p.toString());
            };

            $(elem_selected).find('.participant').remove();


            var elem = ($(event.target).hasClass('kurs') ? event.target : $(event.target).parents('.kurs'));

            $('.kurs').removeClass('selected');
            $(elem).addClass('selected');

           this.updateSelectedKurs(this.menge);

        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['menge']) {
            //wenn Menge geändert wurde --> Anzahl der Namensfelder ändern
            //console.log('Value changed:', changes['menge'].currentValue);

           // this.updateSelectedKurs(changes['menge'].currentValue);
           this.updateSelectedKurs(this.menge);

        }
    }

    updateSelectedKurs(c:number=1) {
        //die Anzahl der Inputs für Teilnhmer aktualisieren

        var elem = $('.kurs.selected');
        
        //Inputs entfernen
        $(elem).find('.participant').remove();

        //neue Anzahl an Inputs hinzufügen
        for (let i = 0; i < c; i++) {
            let pid = "participant"+(i).toString();
            $(elem).find('.participant_list').append('<input type="text" id="'+pid+'" class="participant" name="" value="" placeholder="Teilnehmer '+(i+1).toString()+'">');
        }

        //aus gemerkten Teilnehmern max Anzahl einfügen
        for (let i = 0; i < $(elem).find('.participant').length; i++) {
            let p_elem = $(elem).find('#participant'+i);
            $(p_elem).val(this.dynArrParticipant[i]);
        }

        this.selectedKursId = Number($(elem).find('.div_kurs').attr('id'));
        this.selectedTerminId = Number($(elem).find('.div_termin').attr('id'));

    }

    //Methode, um die "selectedKursdaten" zurückzugeben
    getSelectedKurs(): Kurse.ISelectedKursDto {

        const newKurs: Kurse.ISelectedKursDto = {            
            kursId: this.selectedKursId,
            terminId: this.selectedTerminId,
            teilnehmer: this.dynArrParticipant // das dynamische Teilnehmer-Array
        };
    
        return newKurs;
    }

    /*
    getProgressWidth(): string {

        const progress = (this.kurse[0].buchungenAktuell * 100) / this.kurse[0].kapazitaet;
        if (progress < 0) {
          return '0%';
        } else if (progress > 100) {
          return '100%';
        } else {
          return progress + '%';
        }

        
    }
        */
}